<template>
  <div class="manage-podcast">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Quản lý podcast</h3>
      </el-row>
      <el-button
        type="primary"
        @click="$router.push({ name: 'ManagePodcast' })"
      >
        Thêm
      </el-button>
    </el-row>
    <el-form :model="form" inline ref="form">
      <el-form-item>
        <el-input
          v-model="form.name"
          @input="handleSearch"
          clearable
          placeholder="Tìm kiếm podcast theo tên"
          class="search mb-xl"
        />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button size="medium" class="mb-m" @click="handleRefreshData">
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="podcasts" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Tên" min-width="200px">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'UpdatePodcast', params: { id: scope.row.id } }"
          >
            {{ scope.row.name }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="Mô tả" min-width="250px">
        <template slot-scope="scope"> {{ scope.row.description }} </template>
      </el-table-column>
      <el-table-column label="Ngày tạo" width="120px">
        <template slot-scope="scope">
          {{ scope.row.created_at | convertDate }}
        </template>
      </el-table-column>
      <el-table-column label="Ảnh đại diện" width="150px">
        <template slot-scope="scope">
          <img :src="scope.row.photo_url_path" class="preview-avatar" alt="" />
        </template>
      </el-table-column>
      <el-table-column label="Hiển thị trang chủ" width="100px" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.show_home"
            @change="handleUpdatePodcast(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="Hiển thị" width="100px" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleUpdatePodcast(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="Sửa" align="center" width="70px" fixed="right">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'UpdatePodcast', params: { id: scope.row.id } }"
          >
            <el-button type="primary" size="small" icon="el-icon-edit" circle />
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="Xoá" align="center" width="70px" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            circle
            @click="handleRemovePodcast(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="handleChangePage"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchPodcast, deletePodcast } from "@/services/podcast";
import { updatePodcast } from "../../services/podcast";
import { replaceUrlResourceBlog } from "@/utils/common";
export default {
  name: "ManagePodcast",
  data() {
    return {
      callingAPI: false,

      form: {
        name: "",
      },
      podcasts: [],

      page: 1,
      total: 0,
      pageSize: 10,

      debounce: null,
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.$refs.form.resetFields();
      await this.loadData();
    },
    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          name: this.form.name,
          offset: page ? (page - 1) * this.pageSize : 0,
          limit: this.pageSize,
        };
        const response = await fetchPodcast(params);
        this.podcasts = response.data.posts.map((p) => ({
          ...p,
          show_home: p.show_home !== null ? true : false,
          status: p.status == 1 ? true : false,
          photo_url_path: replaceUrlResourceBlog(p.photo_url_path),
        }));
        this.total = response.data.paginate.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },
    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },
    async handleSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleUpdatePodcast(row) {
      this.callingAPI = true;
      console.log(row);
      const data = {
        ...row,
        show_home: row.show_home ? 1 : null,
        status: row.status ? 1 : 2,
      };

      const response = await updatePodcast(row.id, data);
      if (response.status == 1) {
        this.$notify.success({
          title: "Thành công",
          message: "Cập nhật podcast thành công.",
          duration: 2000,
        });
      } else {
        this.$notify.error({
          title: "Thất bại",
          message: "Cập nhật podcast thất bại.",
          duration: 2000,
        });
      }
      this.callingAPI = false;
    },

    async handleRemovePodcast(row) {
      this.$confirm(`Chắc chắn muốn xoá podcast ${row.name} ?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(async () => {
          try {
            this.callingAPI = true;
            await deletePodcast(row.id);
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Xoá podcast ${row.name} thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: "Xoá podcast thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>

<style lang="scss">
.manage-podcast {
  .preview-avatar {
    max-width: 100%;
    object-fit: cover;
  }
}
</style>
